module.exports = __webpack_public_path__ + "img/16_109.58d8cb81.png";